import React, { useCallback } from 'react';
import * as Yup from 'yup';
import { HeadingWithCreateBtn, Search, Table, CrudIcon } from 'src/components';
import { DashboardLayout } from 'src/containers';
import useFetch from 'src/hooks/useFetch';
import AddFloor from './crud/AddEditFloor';
import { toastAlert } from 'src/utils/toastAlert';
import { shallowEqual, useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchFloor } from 'src/redux/action/floor.action';
import { MdEdit } from 'react-icons/md';
import { AiOutlinePlus } from 'react-icons/ai';
import Button from 'src/components/button';
import Loader from 'src/components/loader';

interface IProps {}

const FORM_VALIDATION = Yup.object().shape({
  floorName: Yup.string()
    .min(3, 'Floor Name must a at least 3 character long')
    .required('Floor name is required'),
  tableName: Yup.string().required(''),
});

const Floors: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(true);
  const [query, setQuery] = React.useState('');
  const [isEdit, setIsEdit] = React.useState(false);
  const [editId, setEditId] = React.useState('');
  const [editFloorData, setEditFloorData] = React.useState();
  const dispatch = useDispatch();

  const handleModal = useCallback(() => {
    setIsEdit(false);
    setEditId('');
    setShowModal(!showModal);
  }, [showModal]);

  const handleEdit = useCallback((data: any) => {
    setEditFloorData(data);
    setIsEdit(true);
    setEditId(data.id);
    setShowModal(true);
  }, []);

  const { floorData, loading } = useSelector(
    ({ floorData }: RootState) => floorData,
    shallowEqual
  );

  React.useEffect(() => {
    if (floorData.length > 0) return;
    dispatch(fetchFloor() as any);
  }, [dispatch]);

  const searchFloorFilterData = floorData?.filter((item) => {
    if (query === '') {
      return item;
    } else if (item) {
      return item?.name?.toLowerCase().includes(query.toLowerCase());
    }
  });
  const tableColumn = [
    { Header: 'Area Name', accessor: 'name' },
    { Header: 'Pax', accessor: 'totalPax' },
    { Header: 'Table no.', accessor: 'numberOfTables' },
    {
      Header: 'Action',
      Cell: (row: any) => (
        <CrudIcon
          data={row?.cell?.row?.original}
          url="/floors/remove"
          // fetchData={() => {}}
          fetchData={fetchFloor() as any}
        >
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() => handleEdit(row?.cell?.row?.original)}
          >
            <MdEdit color="#4062FF" />
          </div>
        </CrudIcon>
      ),
    },
  ];
  return (
    <>
      <div className="grid grid-cols-12 gap-10">
        <div className="col-span-12 xl:col-span-9">
          {/* <HeadingWithCreateBtn
            icon={<AiOutlinePlus size={20} />}
            title="floors"
            btnTxt="create floors"
            onClick={handleModal}
          />
          <Search
            placeholder="search floor"
            query={query}
            setQuery={setQuery}
          /> */}
          <div className="flex items-center justify-between ">
            <Search
              placeholder="search area"
              query={query}
              setQuery={setQuery}
            />
            <Button
              text={'Add Area'}
              variant="primary"
              onClick={handleModal}
              icon={<AiOutlinePlus size={20} />}
            />
          </div>
          <div className="pb-10">
            <Table
              loading={loading}
              pagination={true}
              tableColumn={tableColumn}
              tableData={searchFloorFilterData ?? []}
            />
          </div>
        </div>

        {/* add modal */}

        <AddFloor
          editFloorData={editFloorData}
          handleModal={handleModal}
          showModal={showModal}
          editId={editId}
          isEdit={isEdit}
          setEditId={setEditId}
          setIsEdit={setIsEdit}
        />
      </div>
    </>
  );
};

export default React.memo(Floors);
